(function () {
  function initCollection(section) {
    var sortSelect = section.querySelector('[data-tcb-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var perPageSelect = section.querySelector('[data-tcb-per-page]');
    if (perPageSelect) {
      perPageSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('limit', perPageSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var filterForm = section.querySelector('[data-tcb-filter-form]');
    if (filterForm) {
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
        input.addEventListener('change', function () {
          filterForm.submit();
        });
      });
    }

    var filterToggle = section.querySelector('[data-tcb-filter-toggle]');
    var filterDrawer = section.querySelector('[data-tcb-filter-drawer]');
    var filterOverlay = section.querySelector('.tcb-collection-page__drawer-overlay');
    var filterClose = section.querySelectorAll('[data-tcb-filter-close]');

    function closeDrawer() {
      document.body.classList.remove('tcb-filter-open');
      if (filterOverlay) filterOverlay.hidden = true;
    }

    function openDrawer() {
      document.body.classList.add('tcb-filter-open');
      if (filterOverlay) filterOverlay.hidden = false;
    }

    if (filterToggle && filterDrawer) {
      filterToggle.addEventListener('click', openDrawer);
      filterClose.forEach(function (btn) {
        btn.addEventListener('click', closeDrawer);
      });
    }

    section.querySelectorAll('[data-tcb-clear-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-url') || section.dataset.collectionUrl;
        if (window.TcbSecurity && !window.TcbSecurity.isSafeInternalPath(target)) {
          target = section.dataset.collectionUrl || window.location.pathname;
        }
        window.location.href = target;
      });
    });

    section.querySelectorAll('[data-tcb-hero-video]').forEach(initHeroVideo);
  }

  function initHeroVideo(player) {
    if (player.dataset.heroVideoInit === 'true') return;
    player.dataset.heroVideoInit = 'true';

    var playButton = player.querySelector('[data-tcb-video-play]');
    if (!playButton) return;

    playButton.addEventListener('click', function () {
      if (player.dataset.videoReady !== 'true') return;

      var iframe = player.querySelector('iframe[data-src]');
      if (iframe && !iframe.src) {
        iframe.src = iframe.getAttribute('data-src');
      }

      var video = player.querySelector('video');
      if (video) {
        video.controls = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      player.classList.add('is-playing');
      playButton.setAttribute('aria-pressed', 'true');
    });
  }

  document.querySelectorAll('[data-section-type="tcb-collection-page"]').forEach(initCollection);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="tcb-collection-page"]');
    if (section) initCollection(section);
  });
})();
